import React, { useState } from "react";
import API from "../api/axios";
import DashboardLayout from "../layout/DashboardLayout";
import "./Export.css";

const ExportPage = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  const handleExcelExport = async () => {
    if (!fromDate || !toDate) {
      alert("Please select From and To dates");
      return;
    }

    if (fromDate > toDate) {
      alert("From date cannot be greater than To date");
      return;
    }

    setLoading(true);
    try {
      const res = await API.get(
        `/bilties/excel?fromDate=${fromDate}&toDate=${toDate}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `bilties-${fromDate}_to_${toDate}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Excel Export Error:", err);
      alert("Excel export failed");
    }
    setLoading(false);
  };

  return (
    <DashboardLayout>
      <div className="export-page">
        <div className="export-header">
          <h2>Export Bilties</h2>
          <p>Select a date range to export bilties as an Excel file.</p>
        </div>

        <div className="export-card">
          <div className="export-filters">
            <div className="date-input">
              <label>From Date</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="date-input">
              <label>To Date</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            <button
              className="btn-export"
              onClick={handleExcelExport}
              disabled={loading}
            >
              {loading ? "Exporting..." : "Export Excel"}
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ExportPage;
